import React, { Component } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import SubmitButton from "../../../AuthPage/UtilFormInputs/SubmitButton/SubmitButton.component";
import PasswordInput from "../../../AuthPage/UtilFormInputs/PasswordInput/PasswordInput.component";
import ValidationPill from "../../../AuthPage/SignupCard/SignupForm/ValidationPill/ValidationPill.component";
import { validationPillStrings } from "../../../AuthPage/SignupCard/SignupForm/ValidationPill/ValidationPill.string";
import "./PasswordForm.scss";
import BaseInputComponent from "../../../../../../components/utils/InputHOC/BaseInputComponent.component";
import { baseInputStrings } from "../../../../../../components/utils/InputHOC/BaseInput.strings";
import { enhancedInput } from "../../../../../../components/utils/InputHOC/InputHOC";
import { withRouter } from "react-router-dom";

export interface PasswordFormProps {
    onSubmit?: (credentials) => {};
}

const initialValues = {
    email: "",
    code: "",
    password: "",
    confirmPassword: ""
};

const MIN_PASS_LENGTH = 8;
const LOWER_CASE_REGEX = /(?=.*[a-z])/;
const UPPER_CASE_REGEX = /(?=.*[A-Z])/;
const DIGIT_REGEX = /(?=.*\d)/;
const SYMBOL_REGEX = /[-!$#%^&*@()_+|~=`{}\[\]:";'<>?,.\/]/;

function equalTo(ref, msg) {
    return this.test({
        name: "equalTo",
        exclusive: false,
        message: msg || "${path} must be the same as ${reference}",
        params: {
            reference: ref.path
        },
        test: function (value) {
            return value === this.resolve(ref);
        }
    });
}

Yup.addMethod(Yup.string, "equalTo", equalTo);

const validationSchema = Yup.object().shape({
    email: Yup.string()
        .email("e-mail is not valid")
        .required("e-mail is required"),
    code: Yup.string().required("e-mail is required"),
    password: Yup.string()
        .required("Password is required")
        .matches(LOWER_CASE_REGEX, "Password must contain lower case character")
        .matches(UPPER_CASE_REGEX, "Password must contain upper case character")
        .matches(DIGIT_REGEX, "Password must contain digit")
        .matches(SYMBOL_REGEX, "Password must symbol (@$%*?&)")
        .min(MIN_PASS_LENGTH, `MIN_LENGTH{${MIN_PASS_LENGTH}}`),
    confirmPassword: Yup.string()
        .required("Password is required")
        //@ts-ignore
        .equalTo(Yup.ref("password"))
});

class PasswordForm extends Component<PasswordFormProps, {}> {
    constructor(_props) {
        super(_props);

        initialValues["email"] = _props.match.params.email || "";
        initialValues["code"] = _props.match.params.token || "";
    }

    render() {
        const emailInput = enhancedInput({
            WrappedComponent: BaseInputComponent,
            id: "Email",
            placeholder: baseInputStrings.EMAIL,
            inputType: "email"
        });

        const codeInput = enhancedInput({
            WrappedComponent: BaseInputComponent,
            id: "ValidationCode",
            placeholder: baseInputStrings.VALIDATION_CODE,
            inputType: "text"
        });

        return (
            <div className="recover-form">
                <Formik
                    initialValues={initialValues}
                    onSubmit={values => this.props.onSubmit(values)}
                    validationSchema={validationSchema}
                    render={props => {
                        return (
                            <Form>
                                <Field
                                    className="auth-form-input"
                                    name="email"
                                    component={emailInput}
                                />
                                <Field
                                    className="auth-form-input"
                                    name="code"
                                    component={codeInput}
                                />
                                <Field
                                    className="auth-form-input"
                                    name="password"
                                    placeholder="New Password"
                                    component={PasswordInput}
                                />
                                <Field
                                    className="auth-form-input"
                                    name="confirmPassword"
                                    placeholder="Confirm Password"
                                    component={PasswordInput}
                                />

                                <div id="password-validators-container">
                                    <ValidationPill
                                        pattern={LOWER_CASE_REGEX}
                                        caption={
                                            validationPillStrings.LOWER_CASE
                                        }
                                        currentPassword={props.values.password}
                                    />
                                    <ValidationPill
                                        pattern={UPPER_CASE_REGEX}
                                        caption={
                                            validationPillStrings.UPPER_CASE
                                        }
                                        currentPassword={props.values.password}
                                    />
                                    <ValidationPill
                                        pattern={DIGIT_REGEX}
                                        caption={validationPillStrings.DIGITS}
                                        currentPassword={props.values.password}
                                    />
                                    <ValidationPill
                                        pattern={SYMBOL_REGEX}
                                        caption={validationPillStrings.SYMBOLS}
                                        currentPassword={props.values.password}
                                    />
                                </div>
                                <div className="auth-form-btns">
                                    <Field component={SubmitButton} />
                                </div>
                            </Form>
                        );
                    }}
                />
            </div>
        );
    }
}

export default withRouter(PasswordForm);
